import React, { useMemo, useState } from "react";
import Table from "../../../shared/components/common/Table";
import SystemStatusIcon from "../../../assets/icons/SystemOperationalIcon.svg";

const formatLastUpdated = (value) => {
  const text = String(value || "").trim();
  if (!text) return "-";

  // Convert ISO-like values (2027-01-23 14:19)
  const isoLikeMatch = text.match(/^(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2})/);
  if (isoLikeMatch) {
    return `${isoLikeMatch[1]} ${isoLikeMatch[2]}`;
  }

  const date = new Date(text);
  if (Number.isNaN(date.getTime())) {
    return text;
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}`;
};

const getStatusBadge = (status) => {
  const statusLower = status?.toLowerCase();
  
  let bgColor, textColor, borderColor;
  
  switch (statusLower) {
    case "operational":
      bgColor = "bg-success/20";
      textColor = "text-statsGreen";
      break;
    case "partial issues":
      bgColor = "bg-statsOrange/20";
      textColor = "text-statsOrange";
      break;
    case "experiencing delays":
      bgColor = "bg-orange/20";
      textColor = "text-orange";
      break;
    case "down":
      bgColor = "bg-statsRed/20";
      textColor = "text-statsRed";
      break;
    default:
      bgColor = "bg-surface/50";
      textColor = "text-muted";
  }
  
  return (
    <span
      className={`px-3 py-1 rounded-md text-xs ${bgColor} ${textColor} `}
    >
      {status}
    </span>
  );
};

const ServiceStatusTable = ({ services = [], loading = false }) => {
  const [currentPage, setCurrentPage] = useState(0);

  const columns = useMemo(
    () => [
      {
        Header: "Service Name",
        accessor: "serviceName",
        disableSortBy: true,
        Cell: ({ value }) => (
          <span className="text-content text-xs sm:text-sm font-medium">
            {value}
          </span>
        ),
      },
      {
        Header: "Last Updated",
        accessor: "lastUpdated",
        disableSortBy: true,
        Cell: ({ value }) => (
          <span className="text-content text-xs sm:text-sm">{formatLastUpdated(value)}</span>
        ),
      },
      {
        Header: "Status",
        accessor: "status",
        disableSortBy: true,
        Cell: ({ value }) => getStatusBadge(value),
      },
      {
        Header: "Notes",
        accessor: "notes",
        disableSortBy: true,
        Cell: ({ value }) => (
          <span className="text-content text-xs sm:text-sm">{value}</span>
        ),
      },
    ],
    []
  );

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-line p-4 sm:p-6">
      <div className="mb-6">
        <div className="flex items-center gap-2">
        <img src={SystemStatusIcon} alt="All services icon" />
        <h2 className="text-lg font-bold text-primary">All Services Status</h2>
        </div>
        <p className="text-sm text-muted mt-1">
          Monitor the real-time status of all our services and any ongoing issues.
        </p>
      </div>
      <div className="logs-table-area border border-line rounded-lg ">
      <Table
        columns={columns}
        data={services}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        pageSize={10}
        loading={loading}
        tableFooter={false}
        />
        </div>
    </div>
  );
};

export default ServiceStatusTable;
